import {Component, Input, OnInit, SimpleChanges, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';

@Component({
    selector: 'app-sidebar-summary',
    templateUrl: './sidebar-summary.component.html',
    encapsulation: ViewEncapsulation.Emulated,
    styleUrls: ['./sidebar-summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SidebarSummaryComponent implements OnInit {
  @Input() parts: any;
  @Input() formGroup: UntypedFormGroup;
  @Input() form: any = {config: {parts: []}};
  @Input() selectedFormIndex: number;
  @Input() metrics: any;
  data: any;

  constructor() {

  }

  changeDetected(): void {
  }


  ngOnInit() {
    this.data = this.formGroup.controls;
  }
}
